/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StbGroupResponse,
    StbGroupResponseFromJSON,
    StbGroupResponseFromJSONTyped,
    StbGroupResponseToJSON,
} from './StbGroupResponse';

/**
 * 
 * @export
 * @interface StbGroupsResponse
 */
export interface StbGroupsResponse {
    /**
     * 
     * @type {Array<StbGroupResponse>}
     * @memberof StbGroupsResponse
     */
    elements: Array<StbGroupResponse>;
    /**
     * 
     * @type {number}
     * @memberof StbGroupsResponse
     */
    totalElementCount: number | null;
}

export function StbGroupsResponseFromJSON(json: any): StbGroupsResponse {
    return StbGroupsResponseFromJSONTyped(json, false);
}

export function StbGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(StbGroupResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function StbGroupsResponseToJSON(value?: StbGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(StbGroupResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

